module.exports = __webpack_public_path__ + "img/slider-14.370ffcfd.jpg";